import classNames from 'classnames';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';

export const SectionHeading = ({ className, title, controls, onGoBack, lined = true }) => {
	return (
		<div className={classNames('layout-sidebar-sectionheading', className, { lined })}>
			<div className="sectionheading-content">
				{onGoBack && (
					<button onClick={onGoBack} type="button" className="sectionheading-backbtn">
						<Icon name="arrow-left" />
					</button>
				)}
				<h1 className="sectionheading-title">{title}</h1>
			</div>
			{controls && <div className="sectionheading-controls">{controls}</div>}
		</div>
	);
};

export default SectionHeading;
